import Container from "components/grid/container";
import { Ga4WithEventParameters } from "src/helpers/google-tag-manager/events/ga4-with-eventparameters";

import styles from "./styles.module.css";

const CyprusBanner = () => {
  const handleCyprusBannerClick = () => {
    Ga4WithEventParameters({
      eventName: "click_banner",
      eventParameters: { widget: "anasayfa-banner-kibris" },
    });
  };

  return (
    <div className={styles.bannerWrapper}>
      <Container>
        <a
          href="/kibris-yatirim-firsatlari"
          className={styles.widgetWrapper}
          onClick={handleCyprusBannerClick}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="/assets/images/cyprus-banner.webp" alt="cyprus routing banner" />
        </a>
      </Container>
    </div>
  );
};

export default CyprusBanner;
